<template>
  <div class="wrap">
    <div style="width: 100%; margin: 20px 0">
      <el-form
        ref="form"
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="姓名" prop="cusname">
              <el-input v-model="editForm.cusname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="服务类型" prop="type">
              <el-select v-model="editForm.type" placeholder="全部">
                <el-option label="居家服务" value="1"></el-option>
                <el-option label="机构" value="2"></el-option>
                <el-option label="适老化改造" value="3"></el-option>
                <el-option label="家庭床位" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="活动时间">
              <el-col :span="8">
                <el-date-picker
                  type="date"
                  placeholder="开始时间"
                  v-model="editForm.startTime"
                  :picker-options="startTime"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="8">
                <el-date-picker
                  type="date"
                  placeholder="结束日期"
                  v-model="editForm.endTime"
                  :picker-options="endTime"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item size="large">
          <el-button type="primary" @click="onSubmit(editForm)"
            >立即查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div style="width: 90%; margin: 0 10%">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="cusname" label="老人姓名" width="180">
        </el-table-column>
        <el-table-column prop="relationName" label="联系人" width="180">
        </el-table-column>
        <el-table-column prop="type" label="服务类型" width="180">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.type === 1" type="success"
              >居家服务</el-tag
            >
            <el-tag size="small" v-else-if="scope.row.type === 2" type="danger"
              >机构养老</el-tag
            >
            <el-tag size="small" v-else-if="scope.row.type === 3" type="danger"
              >适老化改造</el-tag
            >
            <el-tag size="small" v-else-if="scope.row.type === 4" type="danger"
              >家庭床位</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="relationPhone" label="预约电话">
        </el-table-column>
        <el-table-column prop="serviceAddress" label="地址"> </el-table-column>
        <el-table-column prop="subscribeTime" label="预约时间">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row.id)"
              type="text"
              size="small"
              >修改</el-button
            >
            <el-divider direction="vertical"></el-divider>

            <template>
              <el-popconfirm
                title="这是一段内容确定删除吗？"
                @confirm="delHandle(scope.row.id)"
              >
                <el-button type="text" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <!--新增对话框-->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="80rem"
        :before-close="handleClose"
      >
        <el-form
          :model="sizeForm"
          :rules="sizeFormRules"
          ref="editForm"
          label-width="100px"
          class="demo-editForm"
        >
          <el-form-item label="老人姓名" prop="cusname" label-width="100px">
            <el-input v-model="sizeForm.cusname" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="relationName" label-width="100px">
            <el-input
              v-model="sizeForm.relationName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="预约电话"
            prop="relationPhone"
            label-width="100px"
          >
            <el-input
              v-model="sizeForm.relationPhone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="serviceAddress" label-width="100px">
            <el-input
              v-model="sizeForm.serviceAddress"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="预约时间">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="sizeForm.subscribeTime"
                :picker-options="expireTimeOption"
                style="width: 100%"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('sizeForm')"
              >立即预约</el-button
            >
            <el-button @click="resetForm('sizeForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "order",
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() <= Date.now();
        },
      },
      userInfo: {
        id: "",
        username: "7777",
        avatar: "",
      },
      username: "",
      dialogVisible: false,
      sizeForm: {},
      sizeFormRules: {},
      tableData: [],
      editForm: {},
      editFormRules: {
        cusname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
      },
      startTime: {
        disabledDate: (time) => {
          if (this.sizeForm.endTime) {
            return (
              time.getTime() > new Date(this.sizeForm.endTime).getTime() //这里的this.params.endData按自己的字段参数来
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      endTime: {
        disabledDate: (time) => {
          if (this.sizeForm.startTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.sizeForm.startTime).getTime() //这里的this.params.beginDate按自己的字段参数来
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
    };
  },
  created() {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo != null) {
      this.userInfo = JSON.parse(userInfo);
    }
    this.init(this.editForm);
  },
  computed: {
    menuList: {
      get() {
        return this.$store.state.menus.menuList;
      },
    },
  },
  methods: {
    handleClose() {
      this.resetForm("editForm");
      this.dialogVisible = false;
    },
    onSubmit(res) {
      this.init(res);
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.dialogVisible = true;
      this.sizeForm = {};
    },
    handleClick(id) {
      this.$axios.get("gw/subscribe/order/info/" + id).then((res) => {
        this.sizeForm = res.data.data;

        this.dialogVisible = true;
      });
    },
    init(res) {
      var obj = {};
      obj.userId = this.userInfo.id;
      if (res != null) {
        obj = {
          cusname: res.cusname,
          type: res.type,
          startTime: res.startTime,
          endTime: res.endTime,
          userId: this.userInfo.id,
        };
      }

      this.$axios.post("/gw/subscribe/order/list/1", obj).then((res) => {
        this.tableData = res.data.data.records;
      });
    },
    submitForm() {
      this.sizeForm.userId = this.userInfo.id;
      this.sizeForm.username = this.userInfo.username;
      this.sizeForm.createId = this.userInfo.id;
      this.sizeForm.createName = this.userInfo.username;
      this.$axios
        .post("/gw/subscribe/order/update", this.sizeForm)
        .then((res) => {
          if (res.status == 200) {
            this.$message({
              showClose: true,
              message: "恭喜你，操作成功",
              type: "success",
              onClose: () => {
                // this.$router.go(-1);//返回上一层
                this.dialogVisible = false;
                this.init();
              },
            });
          } else {
            this.$message({
              message: "创建失败",
              type: "warning",
            });
          }
        });
    },
    delHandle(id) {
      var ids = [];

      if (id) {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((row) => {
          ids.push(row.id);
        });
      }

      this.$axios.post("/gw/subscribe/order/delete", ids).then((res) => {
        this.$message({
          showClose: true,
          message: "恭喜你，操作成功",
          type: "success",
          onClose: () => {
            this.init();
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.wrap {
  height: 7.1875rem /* 115px -> 7.1875rem */;
  width: 100%;
}

.header-left {
  float: left;
  width: 18.75rem /* 300px -> 18.75rem */;
  height: 100%;
  margin-left: 15.625rem /* 250px -> 15.625rem */;
  color: #000;
}

.address {
  float: left;
}

.header-right-line {
  float: right;
  color: #000;
  width: 9.375rem /* 150px -> 9.375rem */;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.header-right {
  float: right;
  color: #000;
  width: 10rem /* 160px -> 10rem */;
  margin-right: 13.75rem /* 220px -> 13.75rem */;
}

.login {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  height: 7.1875rem /* 115px -> 7.1875rem */;
}

.login:hover {
  height: 7rem /* 112px -> 7rem */;
  border-bottom: 3px solid #e6a23c;
}

.registered {
  float: left;
  width: 5rem /* 80px -> 5rem */;
  line-height: 7.1875rem /* 115px -> 7.1875rem */;
  height: 7.1875rem /* 115px -> 7.1875rem */;
}

.registered:hover {
  height: 7rem /* 112px -> 7rem */;
  border-bottom: 3px solid #f77f00;
}

.el-main {
  color: #333;
  padding: 0;
  width: 100%;
}
</style>
